import { AIRCRAFT_STATUS, Aircraft } from '@models/aircraft.model';

import { getClientID } from './clients';

export const AIRCRAFT_ID_PREFIX = 'AC-';
export const getAircraftID = (index: number) => `${AIRCRAFT_ID_PREFIX}${index}`;

export const mockAircraft: Aircraft[] = [
  {
    documentID: getAircraftID(1),
    clientID: getClientID(1),
    registration: 'N12345',
    serialNumber: 'S/N 1001',
    model: 'Cessna 172',
    manufacturer: 'Cessna',
    year: 2005,
    status: AIRCRAFT_STATUS.ACTIVE,
    airframe: {
      totalTimeSinceNew: 2693.2,
      landingsSinceNew: 771,
      airWorthnessDate: new Date('2016-06-01'),
      maintenanceTracking: 'CAMP',
      programCoverage: 'Rolls-Royce CorporateCare',
    },
    engines: {
      model: 'BR725',
      manufacturer: 'Rolls-Royce',
      programCoverage: 'Coverage A',
      engineL: {
        serialNumber: 'ENG-L-1',
        hoursSinceNew: 1010,
        cyclesSinceNew: 505,
      },
      engineR: {
        serialNumber: 'ENG-R-1',
        hoursSinceNew: 1015,
        cyclesSinceNew: 510,
      },
    },
    avionics: 'Garmin G1000',
    apu: {
      manufacturer: 'Honeywell',
      model: 'RE220',
      serialNumber: 'APU-1',
      timeSinceNew: 505,
      programCoverage: 'APU Coverage',
    },
    connectivityAndEntertainment: {
      internet: 'SwiftBroadband',
      phone: 'Aircell Axxess II',
      display: 'Forward Cabin Display',
    },
    aircraftServiceChanges: [{ service: 'ASC 101' }],
    interior: {
      noOfPassengers: 8,
      galleryLocation: 'Forward Galley',
      forwardCabinConfiguration: '4-place club',
      midCabinConfiguration: '2-place divan',
      aftCabinConfiguration: '2-place club',
      lavatory: 'Forward Lavatory',
      crewRestArea: 'No Crew Rest Area',
      jumpSeat: 'No Jump Seat',
      lastRefurbishmentDate: new Date('2020-01-01'),
    },
    exterior: {
      basePaintColor: 'White',
      stripeColor: 'Blue',
      lastRefurbishmentDate: new Date('2020-01-01'),
    },
    majorInspectionStatus: {
      month12: 'Completed December 2020',
      month24: 'Due December 2024',
    },
  },
  {
    documentID: getAircraftID(2),
    clientID: getClientID(1),
    registration: 'G-ABCD',
    serialNumber: 'S/N 1002',
    model: 'Beechcraft King Air',
    manufacturer: 'Beechcraft',
    year: 2010,
    status: AIRCRAFT_STATUS.MAINTENANCE,
    airframe: {
      totalTimeSinceNew: 3000,
      landingsSinceNew: 800,
      airWorthnessDate: new Date('2016-07-01'),
      maintenanceTracking: 'CAMP',
      programCoverage: 'Rolls-Royce CorporateCare',
    },
    engines: {
      model: 'BR725',
      manufacturer: 'Rolls-Royce',
      programCoverage: 'Coverage A',
      engineL: {
        serialNumber: 'ENG-L-2',
        hoursSinceNew: 1020,
        cyclesSinceNew: 510,
      },
      engineR: {
        serialNumber: 'ENG-R-2',
        hoursSinceNew: 1025,
        cyclesSinceNew: 515,
      },
    },
    avionics: 'Garmin G1000',
    apu: {
      manufacturer: 'Honeywell',
      model: 'RE220',
      serialNumber: 'APU-2',
      timeSinceNew: 510,
      programCoverage: 'APU Coverage',
    },
    connectivityAndEntertainment: {
      internet: 'SwiftBroadband',
      phone: 'Aircell Axxess II',
      display: 'Forward Cabin Display',
    },
    aircraftServiceChanges: [{ service: 'ASC 102' }],
    interior: {
      noOfPassengers: 8,
      galleryLocation: 'Forward Galley',
      forwardCabinConfiguration: '4-place club',
      midCabinConfiguration: '2-place divan',
      aftCabinConfiguration: '2-place club',
      lavatory: 'Forward Lavatory',
      crewRestArea: 'No Crew Rest Area',
      jumpSeat: 'No Jump Seat',
      lastRefurbishmentDate: new Date('2020-02-01'),
    },
    exterior: {
      basePaintColor: 'White',
      stripeColor: 'Blue',
      lastRefurbishmentDate: new Date('2020-02-01'),
    },
    majorInspectionStatus: {
      month12: 'Completed November 2020',
      month24: 'Due November 2024',
    },
  },
  {
    documentID: getAircraftID(3),
    registration: 'F-GHIJ',
    serialNumber: 'S/N 1003',
    model: 'Pilatus PC-12',
    manufacturer: 'Pilatus',
    year: 2015,
    status: AIRCRAFT_STATUS.ACTIVE,
    airframe: {
      totalTimeSinceNew: 3200.5,
      landingsSinceNew: 820,
      airWorthnessDate: new Date('2016-08-01'),
      maintenanceTracking: 'CAMP',
      programCoverage: 'Rolls-Royce CorporateCare',
    },
    engines: {
      model: 'BR725',
      manufacturer: 'Rolls-Royce',
      programCoverage: 'Coverage A',
      engineL: {
        serialNumber: 'ENG-L-3',
        hoursSinceNew: 1030,
        cyclesSinceNew: 515,
      },
      engineR: {
        serialNumber: 'ENG-R-3',
        hoursSinceNew: 1035,
        cyclesSinceNew: 520,
      },
    },
    avionics: 'Garmin G1000',
    apu: {
      manufacturer: 'Honeywell',
      model: 'RE220',
      serialNumber: 'APU-3',
      timeSinceNew: 515,
      programCoverage: 'APU Coverage',
    },
    connectivityAndEntertainment: {
      internet: 'SwiftBroadband',
      phone: 'Aircell Axxess II',
      display: 'Forward Cabin Display',
    },
    aircraftServiceChanges: [{ service: 'ASC 103' }],
    interior: {
      noOfPassengers: 8,
      galleryLocation: 'Forward Galley',
      forwardCabinConfiguration: '4-place club',
      midCabinConfiguration: '2-place divan',
      aftCabinConfiguration: '2-place club',
      lavatory: 'Forward Lavatory',
      crewRestArea: 'No Crew Rest Area',
      jumpSeat: 'No Jump Seat',
      lastRefurbishmentDate: new Date('2020-03-01'),
    },
    exterior: {
      basePaintColor: 'White',
      stripeColor: 'Blue',
      lastRefurbishmentDate: new Date('2020-03-01'),
    },
  },
  {
    documentID: getAircraftID(4),
    registration: 'D-KLMN',
    serialNumber: 'S/N 1004',
    model: 'Airbus A320',
    manufacturer: 'Airbus',
    year: 2018,
    status: AIRCRAFT_STATUS.ACTIVE,
    airframe: {
      totalTimeSinceNew: 3300,
      landingsSinceNew: 840,
      airWorthnessDate: new Date('2016-09-01'),
      maintenanceTracking: 'CAMP',
      programCoverage: 'Rolls-Royce CorporateCare',
    },
    engines: {
      model: 'BR725',
      manufacturer: 'Rolls-Royce',
      programCoverage: 'Coverage A',
      engineL: {
        serialNumber: 'ENG-L-4',
        hoursSinceNew: 1040,
        cyclesSinceNew: 520,
      },
      engineR: {
        serialNumber: 'ENG-R-4',
        hoursSinceNew: 1045,
        cyclesSinceNew: 525,
      },
    },
    avionics: 'Garmin G1000',
    apu: {
      manufacturer: 'Honeywell',
      model: 'RE220',
      serialNumber: 'APU-4',
      timeSinceNew: 520,
      programCoverage: 'APU Coverage',
    },
    connectivityAndEntertainment: {
      internet: 'SwiftBroadband',
      phone: 'Aircell Axxess II',
      display: 'Forward Cabin Display',
    },
    aircraftServiceChanges: [{ service: 'ASC 104' }],
    interior: {
      noOfPassengers: 8,
      galleryLocation: 'Forward Galley',
      forwardCabinConfiguration: '4-place club',
      midCabinConfiguration: '2-place divan',
      aftCabinConfiguration: '2-place club',
      lavatory: 'Forward Lavatory',
      crewRestArea: 'No Crew Rest Area',
      jumpSeat: 'No Jump Seat',
      lastRefurbishmentDate: new Date('2020-04-01'),
    },
    exterior: {
      basePaintColor: 'White',
      stripeColor: 'Blue',
      lastRefurbishmentDate: new Date('2020-04-01'),
    },
  },
  {
    documentID: getAircraftID(5),
    registration: 'C-OPQR',
    serialNumber: 'S/N 1005',
    model: 'Boeing 737',
    manufacturer: 'Boeing',
    year: 2012,
    status: AIRCRAFT_STATUS.RETIRED,
    airframe: {
      totalTimeSinceNew: 3400,
      landingsSinceNew: 860,
      airWorthnessDate: new Date('2016-10-01'),
      maintenanceTracking: 'CAMP',
      programCoverage: 'Rolls-Royce CorporateCare',
    },
    engines: {
      model: 'BR725',
      manufacturer: 'Rolls-Royce',
      programCoverage: 'Coverage A',
      engineL: {
        serialNumber: 'ENG-L-5',
        hoursSinceNew: 1050,
        cyclesSinceNew: 525,
      },
      engineR: {
        serialNumber: 'ENG-R-5',
        hoursSinceNew: 1055,
        cyclesSinceNew: 530,
      },
    },
    avionics: 'Garmin G1000',
    apu: {
      manufacturer: 'Honeywell',
      model: 'RE220',
      serialNumber: 'APU-5',
      timeSinceNew: 525,
      programCoverage: 'APU Coverage',
    },
    connectivityAndEntertainment: {
      internet: 'SwiftBroadband',
      phone: 'Aircell Axxess II',
      display: 'Forward Cabin Display',
    },
    aircraftServiceChanges: [{ service: 'ASC 105' }],
    interior: {
      noOfPassengers: 8,
      galleryLocation: 'Forward Galley',
      forwardCabinConfiguration: '4-place club',
      midCabinConfiguration: '2-place divan',
      aftCabinConfiguration: '2-place club',
      lavatory: 'Forward Lavatory',
      crewRestArea: 'No Crew Rest Area',
      jumpSeat: 'No Jump Seat',
      lastRefurbishmentDate: new Date('2020-05-01'),
    },
    exterior: {
      basePaintColor: 'White',
      stripeColor: 'Blue',
      lastRefurbishmentDate: new Date('2020-05-01'),
    },
  },
  {
    documentID: getAircraftID(6),
    clientID: getClientID(6),
    registration: 'I-STUV',
    serialNumber: 'S/N 1006',
    model: 'Embraer Phenom 300',
    manufacturer: 'Embraer',
    year: 2019,
    status: AIRCRAFT_STATUS.ACTIVE,
    airframe: {
      totalTimeSinceNew: 3500,
      landingsSinceNew: 880,
      airWorthnessDate: new Date('2016-11-01'),
      maintenanceTracking: 'CAMP',
      programCoverage: 'Rolls-Royce CorporateCare',
    },
    engines: {
      model: 'BR725',
      manufacturer: 'Rolls-Royce',
      programCoverage: 'Coverage A',
      engineL: {
        serialNumber: 'ENG-L-6',
        hoursSinceNew: 1060,
        cyclesSinceNew: 530,
      },
      engineR: {
        serialNumber: 'ENG-R-6',
        hoursSinceNew: 1065,
        cyclesSinceNew: 535,
      },
    },
    avionics: 'Garmin G1000',
    apu: {
      manufacturer: 'Honeywell',
      model: 'RE220',
      serialNumber: 'APU-6',
      timeSinceNew: 530,
      programCoverage: 'APU Coverage',
    },
    connectivityAndEntertainment: {
      internet: 'SwiftBroadband',
      phone: 'Aircell Axxess II',
      display: 'Forward Cabin Display',
    },
    aircraftServiceChanges: [{ service: 'ASC 106' }],
    interior: {
      noOfPassengers: 8,
      galleryLocation: 'Forward Galley',
      forwardCabinConfiguration: '4-place club',
      midCabinConfiguration: '2-place divan',
      aftCabinConfiguration: '2-place club',
      lavatory: 'Forward Lavatory',
      crewRestArea: 'No Crew Rest Area',
      jumpSeat: 'No Jump Seat',
      lastRefurbishmentDate: new Date('2020-06-01'),
    },
    exterior: {
      basePaintColor: 'White',
      stripeColor: 'Blue',
      lastRefurbishmentDate: new Date('2020-06-01'),
    },
  },
  {
    documentID: getAircraftID(7),
    clientID: getClientID(1),
    registration: 'N67890',
    serialNumber: 'S/N 1007',
    model: 'Cirrus SR22',
    manufacturer: 'Cirrus',
    year: 2020,
    status: AIRCRAFT_STATUS.ACTIVE,
    airframe: {
      totalTimeSinceNew: 3600,
      landingsSinceNew: 900,
      airWorthnessDate: new Date('2016-12-01'),
      maintenanceTracking: 'CAMP',
      programCoverage: 'Rolls-Royce CorporateCare',
    },
    engines: {
      model: 'BR725',
      manufacturer: 'Rolls-Royce',
      programCoverage: 'Coverage A',
      engineL: {
        serialNumber: 'ENG-L-7',
        hoursSinceNew: 1070,
        cyclesSinceNew: 535,
      },
      engineR: {
        serialNumber: 'ENG-R-7',
        hoursSinceNew: 1075,
        cyclesSinceNew: 540,
      },
    },
    avionics: 'Garmin G1000',
    apu: {
      manufacturer: 'Honeywell',
      model: 'RE220',
      serialNumber: 'APU-7',
      timeSinceNew: 535,
      programCoverage: 'APU Coverage',
    },
    connectivityAndEntertainment: {
      internet: 'SwiftBroadband',
      phone: 'Aircell Axxess II',
      display: 'Forward Cabin Display',
    },
    aircraftServiceChanges: [{ service: 'ASC 107' }],
    interior: {
      noOfPassengers: 8,
      galleryLocation: 'Forward Galley',
      forwardCabinConfiguration: '4-place club',
      midCabinConfiguration: '2-place divan',
      aftCabinConfiguration: '2-place club',
      lavatory: 'Forward Lavatory',
      crewRestArea: 'No Crew Rest Area',
      jumpSeat: 'No Jump Seat',
      lastRefurbishmentDate: new Date('2020-07-01'),
    },
    exterior: {
      basePaintColor: 'White',
      stripeColor: 'Blue',
      lastRefurbishmentDate: new Date('2020-07-01'),
    },
  },
  {
    documentID: getAircraftID(8),
    clientID: getClientID(1),
    registration: 'G-XYZ',
    serialNumber: 'S/N 1008',
    model: 'Piper PA-28',
    manufacturer: 'Piper',
    year: 2009,
    status: AIRCRAFT_STATUS.MAINTENANCE,
    airframe: {
      totalTimeSinceNew: 3700,
      landingsSinceNew: 920,
      airWorthnessDate: new Date('2017-01-01'),
      maintenanceTracking: 'CAMP',
      programCoverage: 'Rolls-Royce CorporateCare',
    },
    engines: {
      model: 'BR725',
      manufacturer: 'Rolls-Royce',
      programCoverage: 'Coverage A',
      engineL: {
        serialNumber: 'ENG-L-8',
        hoursSinceNew: 1080,
        cyclesSinceNew: 540,
      },
      engineR: {
        serialNumber: 'ENG-R-8',
        hoursSinceNew: 1085,
        cyclesSinceNew: 545,
      },
    },
    avionics: 'Garmin G1000',
    apu: {
      manufacturer: 'Honeywell',
      model: 'RE220',
      serialNumber: 'APU-8',
      timeSinceNew: 540,
      programCoverage: 'APU Coverage',
    },
    connectivityAndEntertainment: {
      internet: 'SwiftBroadband',
      phone: 'Aircell Axxess II',
      display: 'Forward Cabin Display',
    },
    aircraftServiceChanges: [{ service: 'ASC 108' }],
    interior: {
      noOfPassengers: 8,
      galleryLocation: 'Forward Galley',
      forwardCabinConfiguration: '4-place club',
      midCabinConfiguration: '2-place divan',
      aftCabinConfiguration: '2-place club',
      lavatory: 'Forward Lavatory',
      crewRestArea: 'No Crew Rest Area',
      jumpSeat: 'No Jump Seat',
      lastRefurbishmentDate: new Date('2020-08-01'),
    },
    exterior: {
      basePaintColor: 'White',
      stripeColor: 'Blue',
      lastRefurbishmentDate: new Date('2020-08-01'),
    },
  },
  {
    documentID: getAircraftID(9),
    clientID: getClientID(1),
    registration: 'F-KLMN',
    serialNumber: 'S/N 1009',
    model: 'Diamond DA40',
    manufacturer: 'Diamond',
    year: 2011,
    status: AIRCRAFT_STATUS.ACTIVE,
    airframe: {
      totalTimeSinceNew: 3800,
      landingsSinceNew: 940,
      airWorthnessDate: new Date('2017-02-01'),
      maintenanceTracking: 'CAMP',
      programCoverage: 'Rolls-Royce CorporateCare',
    },
    engines: {
      model: 'BR725',
      manufacturer: 'Rolls-Royce',
      programCoverage: 'Coverage A',
      engineL: {
        serialNumber: 'ENG-L-9',
        hoursSinceNew: 1090,
        cyclesSinceNew: 545,
      },
      engineR: {
        serialNumber: 'ENG-R-9',
        hoursSinceNew: 1095,
        cyclesSinceNew: 550,
      },
    },
    avionics: 'Garmin G1000',
    apu: {
      manufacturer: 'Honeywell',
      model: 'RE220',
      serialNumber: 'APU-9',
      timeSinceNew: 545,
      programCoverage: 'APU Coverage',
    },
    connectivityAndEntertainment: {
      internet: 'SwiftBroadband',
      phone: 'Aircell Axxess II',
      display: 'Forward Cabin Display',
    },
    aircraftServiceChanges: [{ service: 'ASC 109' }],
    interior: {
      noOfPassengers: 8,
      galleryLocation: 'Forward Galley',
      forwardCabinConfiguration: '4-place club',
      midCabinConfiguration: '2-place divan',
      aftCabinConfiguration: '2-place club',
      lavatory: 'Forward Lavatory',
      crewRestArea: 'No Crew Rest Area',
      jumpSeat: 'No Jump Seat',
      lastRefurbishmentDate: new Date('2020-09-01'),
    },
    exterior: {
      basePaintColor: 'White',
      stripeColor: 'Blue',
      lastRefurbishmentDate: new Date('2020-09-01'),
    },
  },
  {
    documentID: getAircraftID(10),
    clientID: getClientID(1),
    registration: 'D-QWER',
    serialNumber: 'S/N 1010',
    model: 'Boeing 777',
    manufacturer: 'Boeing',
    year: 2016,
    status: AIRCRAFT_STATUS.ACTIVE,
    airframe: {
      totalTimeSinceNew: 3900,
      landingsSinceNew: 960,
      airWorthnessDate: new Date('2017-03-01'),
      maintenanceTracking: 'CAMP',
      programCoverage: 'Rolls-Royce CorporateCare',
    },
    engines: {
      model: 'BR725',
      manufacturer: 'Rolls-Royce',
      programCoverage: 'Coverage A',
      engineL: {
        serialNumber: 'ENG-L-10',
        hoursSinceNew: 1100,
        cyclesSinceNew: 550,
      },
      engineR: {
        serialNumber: 'ENG-R-10',
        hoursSinceNew: 1105,
        cyclesSinceNew: 555,
      },
    },
    avionics: 'Garmin G1000',
    apu: {
      manufacturer: 'Honeywell',
      model: 'RE220',
      serialNumber: 'APU-10',
      timeSinceNew: 550,
      programCoverage: 'APU Coverage',
    },
    connectivityAndEntertainment: {
      internet: 'SwiftBroadband',
      phone: 'Aircell Axxess II',
      display: 'Forward Cabin Display',
    },
    aircraftServiceChanges: [{ service: 'ASC 110' }],
    interior: {
      noOfPassengers: 8,
      galleryLocation: 'Forward Galley',
      forwardCabinConfiguration: '4-place club',
      midCabinConfiguration: '2-place divan',
      aftCabinConfiguration: '2-place club',
      lavatory: 'Forward Lavatory',
      crewRestArea: 'No Crew Rest Area',
      jumpSeat: 'No Jump Seat',
      lastRefurbishmentDate: new Date('2020-10-01'),
    },
    exterior: {
      basePaintColor: 'White',
      stripeColor: 'Blue',
      lastRefurbishmentDate: new Date('2020-10-01'),
    },
  },
  {
    documentID: getAircraftID(11),
    clientID: getClientID(1),
    registration: 'C-ASDF',
    serialNumber: 'S/N 1011',
    model: 'Airbus A380',
    manufacturer: 'Airbus',
    year: 2013,
    status: AIRCRAFT_STATUS.RETIRED,
    airframe: {
      totalTimeSinceNew: 4000,
      landingsSinceNew: 980,
      airWorthnessDate: new Date('2017-04-01'),
      maintenanceTracking: 'CAMP',
      programCoverage: 'Rolls-Royce CorporateCare',
    },
    engines: {
      model: 'BR725',
      manufacturer: 'Rolls-Royce',
      programCoverage: 'Coverage A',
      engineL: {
        serialNumber: 'ENG-L-11',
        hoursSinceNew: 1110,
        cyclesSinceNew: 555,
      },
      engineR: {
        serialNumber: 'ENG-R-11',
        hoursSinceNew: 1115,
        cyclesSinceNew: 560,
      },
    },
    avionics: 'Garmin G1000',
    apu: {
      manufacturer: 'Honeywell',
      model: 'RE220',
      serialNumber: 'APU-11',
      timeSinceNew: 555,
      programCoverage: 'APU Coverage',
    },
    connectivityAndEntertainment: {
      internet: 'SwiftBroadband',
      phone: 'Aircell Axxess II',
      display: 'Forward Cabin Display',
    },
    aircraftServiceChanges: [{ service: 'ASC 111' }],
    interior: {
      noOfPassengers: 8,
      galleryLocation: 'Forward Galley',
      forwardCabinConfiguration: '4-place club',
      midCabinConfiguration: '2-place divan',
      aftCabinConfiguration: '2-place club',
      lavatory: 'Forward Lavatory',
      crewRestArea: 'No Crew Rest Area',
      jumpSeat: 'No Jump Seat',
      lastRefurbishmentDate: new Date('2020-11-01'),
    },
    exterior: {
      basePaintColor: 'White',
      stripeColor: 'Blue',
      lastRefurbishmentDate: new Date('2020-11-01'),
    },
  },
  {
    documentID: getAircraftID(12),
    clientID: getClientID(1),
    registration: 'I-ZXCV',
    serialNumber: 'S/N 1012',
    model: 'Embraer Legacy 450',
    manufacturer: 'Embraer',
    year: 2018,
    status: AIRCRAFT_STATUS.MAINTENANCE,
    airframe: {
      totalTimeSinceNew: 4100,
      landingsSinceNew: 1000,
      airWorthnessDate: new Date('2017-05-01'),
      maintenanceTracking: 'CAMP',
      programCoverage: 'Rolls-Royce CorporateCare',
    },
    engines: {
      model: 'BR725',
      manufacturer: 'Rolls-Royce',
      programCoverage: 'Coverage A',
      engineL: {
        serialNumber: 'ENG-L-12',
        hoursSinceNew: 1120,
        cyclesSinceNew: 560,
      },
      engineR: {
        serialNumber: 'ENG-R-12',
        hoursSinceNew: 1125,
        cyclesSinceNew: 565,
      },
    },
    avionics: 'Garmin G1000',
    apu: {
      manufacturer: 'Honeywell',
      model: 'RE220',
      serialNumber: 'APU-12',
      timeSinceNew: 560,
      programCoverage: 'APU Coverage',
    },
    connectivityAndEntertainment: {
      internet: 'SwiftBroadband',
      phone: 'Aircell Axxess II',
      display: 'Forward Cabin Display',
    },
    aircraftServiceChanges: [{ service: 'ASC 112' }],
    interior: {
      noOfPassengers: 8,
      galleryLocation: 'Forward Galley',
      forwardCabinConfiguration: '4-place club',
      midCabinConfiguration: '2-place divan',
      aftCabinConfiguration: '2-place club',
      lavatory: 'Forward Lavatory',
      crewRestArea: 'No Crew Rest Area',
      jumpSeat: 'No Jump Seat',
      lastRefurbishmentDate: new Date('2020-12-01'),
    },
    exterior: {
      basePaintColor: 'White',
      stripeColor: 'Blue',
      lastRefurbishmentDate: new Date('2020-12-01'),
    },
  },
];
